import { Container, CardWrapper, CardColumn } from './TopNewsStyles';
import NewsCardMain from '@/ui/card/newsCards/main/NewsCardMain';

interface TopNewsProps {
  articles?: any[];
}

const TopNews = ({ articles = [] }: TopNewsProps) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div>
        {articles.slice(0, 5).map((article, i) => (
          <div key={i}>
            <NewsCardMain key={i} article={article} number={i + 1} />
          </div>
        ))}
      </div>
      <div>
        {articles.slice(5, 10).map((article, i) => (
          <div key={i}>
            <NewsCardMain key={i + 5} article={article} number={i + 1 + 5} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopNews;
